// Group by Team
export const ROLLOUTS = {
    // Hawks
    HAWKS_ALLOCATE_SELLER_LEVELS_BADGES: 'hawks_allocate_seller_levels_badges',
    HAWKS_SORT_BY_PRICE_POST_FREEZE: 'hawks_sort_by_price_post_freeze',
    QUALAS_NEW_LEVEL_SYSTEM_CONSUMERS_MIGRATION: 'qualas_new_level_system_consumers_migration',
    HAWKS_NEW_MIDDLEWARE_FLOW: 'hawks_new_middleware_flow',
    HAWKS_HIDE_ONLINE_NOW_TOGGLE_FILTER: 'hawks_hide_online_now_toggle_filter',
    HAWKS_FACET_COUNTER_REMOVAL: 'hawks_facet_counter_removal',
    HAWKS_AI_STORE_BUILDER_ENTRY_POINTS: 'hawks_ai_store_builder_entry_points',

    // Crows
    CROWS_EXACT_MATCH_FREELANCER_SEARCH_REDIRECT: 'crows_exact_match_freelancer_search_redirect',
    CROWS_PRO_CATALOG_NO_RESULTS: 'crows_pro_catalog_no_results_rollout',
    CROWS_AI_DIRECTOR_BANNER: 'crows_ai_director_banner',
    CROWS_MP_BFF_EXPANSION: 'crows_mp_bff_expansion',

    // Bulls
    BULLS_AD_LABEL_FULL_CATALOG: 'bulls_ad_label_full_catalog',

    // TODO Group By Team and cleanup
    VIPERS_BRIEF_AND_MATCH_MODAL: 'vipers_brief_and_match_modal',
    CAT_MW_SC_BANNER: 'cat_mw_sc_banner',
    CAT_FETCH_PERSONALIZATION_CONTENT_BY_FUNNEL: 'cat_fetch_personalization_content_by_funnel',
    CAT_I_WILL_PREFIX_REMOVAL: 'cat_i_will_prefix_removal',
    CATERPILLARS_ONLINE_PRO_TOGGLE_REMOVAL: 'caterpillars_online_pro_toggle_removal',
    CAT_REMOVE_MIN_PRICE_TOGGLE: 'cat_remove_min_price_toggle',
    MUSTANGS_CUSTOM_DEFAULT_FILTERS: 'mustangs_custom_default_filters',
    HAWKS_LISTINGS_SIDE_FILTERS: 'hawks_listings_side_filters',
    CARIBOU_RATING_SCORE_UPDATES: 'caribou_rating_score_updates',
    MUSTANGS_PRO_CATALOG_GRID: 'mustangs_pro_catalog_grid',

    // cheetahs
    CHEETAHS_BOOK_PUBLISHING: 'cheetahs_book_publishing',
    CHEETAHS_BOOK_PUBLISHING_ALLOCATION_GUARD: 'cheetahs_book_publishing_allocation_guard',

    // dolphins
    DOLPHINS_HOURLY_RATE_BANNER_LISTINGS_GUEST: 'dolphins_hourly_rate_banner_listings_guest',
    DOLPHINS_LOYALTY_ELIGIBILITY_PRO_MIGRATION_BANNER: 'dolphins_loyalty_eligibility_pro_migration_banner',

    // meerkats
    MEERKATS_LISTINGS_RELATED_SKILLS: 'meerkats_listings_related_skills',
    MEERKATS_LISTINGS_AGGREGATE_RATING: 'meerkats_listings_aggregate_rating',
    MEERKATS_LISTINGS_RELATED_GUIDES: 'meerkats_listings_related_guides',
    MEERKATS_PRO_SKILLS_CATALOG: 'meerkats_pro_skills_catalog',
    // zebras
    FALCONS_AGENCIES_IN_LISTINGS_GD: 'falcons_agencies_in_listings_gd',
    ZEBRAS_NEW_LOYALTY_POINTS: 'zebras_new_loyalty_points',

    // marlins
    MARLINS_LOYALTY_SUNSET: 'marlins_loyalty_sunset',

    // starlings
    STARLINGS_AI_ASSISTANT_FILTER_TOGGLE: 'starlings_ai_assistant_search',

    // piglets
    PIGLETS_ENABLE_PRICE_UPFRONT: 'piglets_enable_price_upfront_display',
};
